import React from 'react';
import { Select, InputDate } from 'Components'
import moment from 'moment'
import { DateRangePicker } from 'Components/uiControls/DatePicker'
import {formatDatetime} from "Modules/reports/views/main/components/reportsTab/helper";

/**
 *  Component to show the date, start date and end date
 *  Select Component
 * @param {label} string
 * @param {option} object
 * @param {onChangeSelect} function
 * @param {placeholder} string
 * @param {required} boolean
 * @param {requiredMessage} string
 * Date Component
 * @param {startDate} date
 * @param {endDate} date
 * @param {onChangeDateRange} function
 * @param {classNameDate} string
 * @returns
 */
const TimeFrame = (props) => {
  // Current day at the end of the day
  const maxDateCurrentDayEnd = moment().endOf('day').toDate();
  return (
    <div style={{ width: "100%" }}>
      <Select
        id="timeframe"
        label={props.label}
        value={props.option}
        onChange={props.onChangeSelect}
        options={props.options}
        textField="label"
        valueField="id"
        placeholder={props.placeholder}
        required={props.required}
        requiredMessage={props.requiredMessage}
        menuPlacement="auto"
        titleStyles={props.titleStyles}
      />
      {
        props.option && props.option.id === "custom" &&
        <div>
          <DateRangePicker
            style={{ paddingTop: 5 }}
            startDate={props.startDate}
            endDate={props.endDate}
            maxDate={maxDateCurrentDayEnd}
            onChange={(start, end) => {
              props.onChangeDateRange({ start, end })
            }}
          />
        </div>
      }
    </div>
  )
};

TimeFrame.defaultProps = {
  type: 'rangetimemodal'
}
export default TimeFrame;
